import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTeacher: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTeacher"><Path d="M12 2C10.067 2 8.5 3.567 8.5 5.5C8.5 7.433 10.067 9 12 9C13.933 9 15.5 7.433 15.5 5.5C15.5 3.567 13.933 2 12 2Z" fill="currentColor"/><Path d="M5 8.5H3V11H2V13H3V21H21V13H22V11H15.6698C14.7685 10.0637 13.484 9.5 12 9.5C10.516 9.5 9.23148 10.0637 8.3302 11H7.5V8.5H5.5V11H5V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTeacher;
